import styles from './underlineButton.module.css';

export default function UnderlineButton ({
  label,
  onClick,
  iconLeft = null,
  iconRight = null,
  isHiddenMobile = false,
  isDisabled = false
}) {
  return (
    <button
      type='button'
      onClick={isDisabled ? () => {} : onClick}
      className={`${styles.buttonContainer} ${isHiddenMobile && styles.hidden}`}
      disabled={isDisabled}
    >
      {iconLeft != null && iconLeft}
      <p className={`${styles.buttonText} ${isDisabled ? styles.disabled : ''}`}>{label}</p>
      {iconRight != null && iconRight}
    </button>
  );
}
